export default {
    syx: "SYX2",
    usdt: "USDT",
    vlx: "VLX",
    eth: "ETH"
};
